var _path, _g, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdcTrc20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12s12-5.373 12-12c0-6.628-5.373-12-12-12z",
    fill: "#4EAF94"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.65 0 12-5.35 12-12S18.65 0 12 0 0 5.35 0 12s5.35 12 12 12z",
    fill: "#2775CA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.001 9.55c-1.45 3.85.55 8.2 4.45 9.6.15.1.3.3.3.45v.7c0 .1 0 .15-.05.2-.05.2-.25.3-.45.2-2.8-.9-4.95-3.05-5.85-5.85-1.5-4.75 1.1-9.8 5.85-11.3.05-.05.15-.05.2-.05.2.05.3.2.3.4v.7c0 .25-.1.4-.3.5-2.05.75-3.7 2.35-4.45 4.45zm9.3-5.8c.05-.2.25-.3.45-.2 2.75.9 4.95 3.05 5.85 5.9 1.5 4.75-1.1 9.8-5.85 11.3-.05.05-.15.05-.2.05-.2-.05-.3-.2-.3-.4v-.7c0-.25.1-.4.3-.5 2.05-.75 3.7-2.35 4.45-4.45 1.45-3.85-.55-8.2-4.45-9.6-.15-.1-.3-.3-.3-.5v-.7c0-.1 0-.15.05-.2zm-2.15 7.55c2.1.25 3.15.85 3.15 2.6 0 1.35-1 2.4-2.5 2.65v1.2c-.05.25-.2.4-.4.4h-.75c-.25-.05-.4-.2-.4-.4v-1.2c-1.65-.25-2.45-1.15-2.65-2.4v-.05c0-.2.15-.35.35-.35h.85c.15 0 .3.1.35.3.15.75.6 1.3 1.9 1.3.95 0 1.65-.55 1.65-1.35s-.45-1.1-1.85-1.35c-2.1-.25-3.1-.9-3.1-2.55 0-1.25.95-2.25 2.45-2.45V6.5c.05-.25.2-.4.4-.4h.75c.25.05.4.2.4.4v1.2c1.15.1 2.05.95 2.25 2.05v.05c0 .2-.15.35-.35.35h-.8c-.15 0-.3-.1-.35-.25-.25-.75-.75-1.05-1.65-1.05-1 0-1.5.45-1.5 1.15s.3 1.1 1.8 1.3z",
    fill: "#fff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#000",
    d: "M-2.5 14h29v7h-29z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.352 15.38v.63h-1.05V20h-.63v-3.99h-1.05v-.63h2.73zM9.663 17.06h.21v-.84h-.21v-.21h-1.26v1.26h1.26v-.21zm.84 1.89V20h-.63v-.84h-.21v-.42h-.21v-.42h-.21v-.42h-.84V20h-.63v-4.62h2.1v.21h.21v.21h.21v.21h.21v1.26h-.21v.21h-.21v.21h-.21v.42h.21v.42h.21v.42h.21zM13.654 18.74v.63h-.21v.21h-.21v.21h-.21V20h-1.26v-.21h-.21v-.21h-.21v-.21h-.21v-.21h-.21v-2.94h.21v-.21h.21v-.21h.21v-.21h.21v-.21h1.26v.21h.21v.21h.21v.21h.21v.63h-.63v-.42h-.21v-.21h-.84v.21h-.21v.21h-.21v2.52h.21v.21h.21v.21h.84v-.21h.21v-.42h.63zM16.806 19.37V20h-2.73v-1.68h.21v-.21h.21v-.21h.21v-.21h.21v-.21h.84v-.21h.21v-.21h.21v-.84h-.21v-.21h-1.05v.21h-.21v.42h-.63v-.63h.21v-.21h.21v-.21h.21v-.21h1.47v.21h.21v.21h.21v.21h.21v1.26h-.21v.21h-.21v.21h-.21v.21h-.21v.21h-.84v.21h-.21v.21h-.21v.84h2.1zM19.117 19.16h.21v-2.1h-.21v.42h-.21v.42h-.21v.42h-.21v.42h-.21v.42h-.21v.21h1.05v-.21zm-.21-2.73h.21v-.42h-1.05v.21h-.21v2.31h.21v-.42h.21v-.42h.21v-.42h.21v-.42h.21v-.42zm1.05-.21v2.94h-.21v.21h-.21v.21h-.21v.21h-.21V20h-1.05v-.21h-.21v-.21h-.21v-.21h-.21v-.21h-.21v-2.94h.21v-.21h.21v-.21h.21v-.21h.21v-.21h1.05v.21h.21v.21h.21v.21h.21v.21h.21z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdcTrc20);
export default __webpack_public_path__ + "static/media/USDC-TRC20.6662c227fdd7b889756a3d391e119cf5.svg";
export { ForwardRef as ReactComponent };